import { Notification } from "@/src/components/organisms";

import { atomWithStorage, createJSONStorage } from "jotai/utils";

const sessionStorage = createJSONStorage<Notification | null>(() =>
  typeof window === "undefined" ? (undefined as never) : window.sessionStorage
);

export const notificationAtom = atomWithStorage<Notification | null>(
  "notification",
  null,
  sessionStorage,
  { getOnInit: true }
);
